// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"c60c4f6c","126":"0341411b","583":"1df3a69c","759":"5cb03dca","828":"28338139"}[chunkId] + ".chunk.js";
};